<script setup>
import { RouterLink } from "vue-router";
import BaseButtonUploadReceipt from "@/components/ui/BaseButtonUploadReceipt.vue";
import { sendMetrik } from "@/utils/metrika";
const props = defineProps({
    activeLink: {
        type: Boolean,
        default: false
    },
    linkUrl: {
        type: String,
        default: ''
    },
	goal : {
		type: String,
		default: ''
	}
})
</script>
<template>
	<div class="game-banner">
		<div class="game-banner__header">
			<slot name="header"></slot>
		</div>
		<div class="game-banner__body">
			<h3 class="game-banner__title"><slot name="title"></slot></h3>
			<p class="game-banner__desc"><slot name="desc"></slot></p>
            <div class="game-banner__sessions">
                <slot name="sessionTimer2"></slot>
                <slot name="sessionTimer1"></slot>
				<slot name="sessionTimer3"></slot>
            </div>
            <RouterLink @click="!!props.goal && sendMetrik('reachGoal', props.goal)" :to="props.linkUrl" v-if="props.activeLink" class="game-banner__btn btn">Играть</RouterLink>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.game-banner {
	border: 1px solid var(--border-accent-2-3);
	border-radius: 2.4rem;
	@extend .base-bg-light;
	margin-top: 1.6rem;	
	&__header {
        backdrop-filter: blur(15.399999618530273px);
        box-shadow: inset 0 13px 35px 0 rgba(255, 255, 255, 0.14), 0 16px 33px 0 rgba(0, 0, 0, 0.25);
        background: rgba(255, 255, 255, 0.01);
		position: relative;
		border: 1px solid var(--border-accent-2-3);
		border-radius: 2.4rem;
		width: 100%;
		height: 12rem;
        overflow: hidden;
		
        @media (max-width: vars.$mn) {
            height: 14.5rem;
        }
        @media (hover: hover) {
            &:hover {
                :deep(.game-banner__link) {
                    background-color: #fff;
                }
            }
        }
	}
	&__body {
        display: grid;
        gap: 10px;
            padding: 2rem 2.4rem 2.4rem;
	}

	&__title {
		font-family: var(--second-family);
		font-weight: 700;
		font-size: 2rem;
		line-height: 110%;
		text-transform: uppercase;
		// text-align: center;
		color: var(--text-accent-2-100);
	}

	&__desc {
		font-weight: 500;
		font-size: 1.6rem;
		line-height: 140%;
		// text-align: center;
		color: var(--text-inverse-100);
	}

	&__sessions {
        display: grid;
        gap: .8rem;
	}

	&__timer-text {
        color: var(--text-accent-2-100);
		font-size: 1.6rem;
		padding: 0 0px 10px;
	}

	&__btn {
		width: 100%;
		min-height: 4.8rem;
		font-size: 2rem;
		border-radius: 1.6rem;
	}
}

:deep(.game-banner__link) {
    position: absolute;
    right: 2rem;
    bottom: 2rem;
    display: grid;
    place-content: center;
    border-radius: 1.2rem;
    width: 3.2rem;
    height: 3.2rem;
    background: var(--fill-accent-2-1);
    z-index: 1;
    transition: background-color var(--transition) ease-in;
    svg {
        width: 2.4rem;
        height: 2.4rem;
        color: var(--text-accent-1-100);
    }
}

:deep(.game-banner__img) {
	position: absolute;
	inset: 0;
	&.active-link {
		cursor: pointer;
	}
}
:deep(.game-banner__timer-text.--warning) {
    color: var(--text-accent-2-100);
    font-size: 1.6rem;
    padding: 10px 0px 10px;
    
}
</style>
